import { gql } from "@apollo/client";

// Subscripción que se activa cuando se recibe un nuevo mensaje de la estación meteorológica
export const OnLastWeatherStationData = gql`
    subscription OnLastWeatherStationData($weather_station_id: Int!) {
        its_weather_station_statuses(
            order_by: {created_at: desc}, 
            limit: 1, 
            where: {
                weather_station_id: {_eq: $weather_station_id}
            }
        ) {
            id
            temperatura_aire: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            temperatura_max: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            temperatura_min: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            humedad_relativa: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            presion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            viento_velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            viento_direccion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            punto_rocio: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`;

// Subscripción que obtiene el último registro de cada estación meteorológica
export const OnAllWeatherStationsLastData = gql`
    subscription OnAllWeatherStationsLastData {
        its_weather_station_statuses(
            order_by: [
                {weather_station_id: asc},
                {created_at: desc}
            ],
            distinct_on: weather_station_id
        ) {
            id
            weather_station_id
            temperatura_aire: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            temperatura_max: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            temperatura_min: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            humedad_relativa: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            presion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            viento_velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            viento_direccion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            punto_rocio: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`; 